import { render, staticRenderFns } from "./CasesView.vue?vue&type=template&id=523fd3bc"
import script from "./CasesView.vue?vue&type=script&setup=true&lang=js"
export * from "./CasesView.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports